import { trackEvent } from './analytics.js';

const REACTIONS = [
  { id: 'like', emoji: '👍', label: 'Me gusta' },
  { id: 'interesting', emoji: '💡', label: 'Interesante' },
  { id: 'surprised', emoji: '😮', label: 'Sorprendente' },
  { id: 'sad', emoji: '😢', label: 'Triste' },
  { id: 'angry', emoji: '😡', label: 'Indignante' }
];

/**
 * Generates the HTML string for the reactions component.
 * @returns {string} The HTML string representing the reaction buttons.
 */
export function buildReactionsHTML() {
  return `
    <div class="reactions-container" id="reactionsComponent">
      <h3 class="reactions-title">¿Qué te pareció esta noticia?</h3>
      <div class="reactions-list">
        ${REACTIONS.map(reaction => `
          <button class="reaction-btn" data-reaction="${reaction.id}" title="${reaction.label}">
            <span class="reaction-emoji">${reaction.emoji}</span>
            <span class="reaction-label">${reaction.label}</span>
          </button>
        `).join('')}
      </div>
      <div class="reaction-feedback" id="reactionFeedback">¡Gracias por tu opinión!</div>
    </div>
  `;
}

/**
 * Sets up event listeners for the reaction buttons and handles analytics tracking.
 * @param {string} newsTitle - The title of the news article for analytics.
 * @param {string} [newsCategory] - The category of the news article for analytics.
 * @returns {void}
 */
export function setupReactions(newsTitle, newsCategory) {
  const container = document.getElementById('reactionsComponent');
  if (!container) return;

  const buttons = container.querySelectorAll('.reaction-btn');
  const feedback = document.getElementById('reactionFeedback');

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const reactionId = btn.getAttribute('data-reaction');
      const reactionLabel = REACTIONS.find(r => r.id === reactionId)?.label || reactionId;

      // Track event using the centralized analytics module
      // We use both custom parameters and standard GA4 parameters for maximum visibility
      trackEvent('post_reaction', {
        'reaction_type': reactionId,
        'reaction_label': reactionLabel,
        'news_title': newsTitle,
        'news_category': newsCategory || 'General',
        // Standard GA4 parameters (helps with built-in reports)
        'item_id': newsTitle, 
        'item_category': newsCategory || 'General',
        'content_type': 'news_reaction'
      });

      // UI Feedback
      buttons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      
      feedback.classList.add('visible');
      
      // Disable after click to prevent multiple votes (simple client-side)
      buttons.forEach(b => b.disabled = true);
      
      // Add a small animation/effect
      btn.style.transform = 'scale(1.2)';
      setTimeout(() => {
        btn.style.transform = '';
      }, 200);
    });
  });
}
